import { Box, Chip } from '@mui/material';
import React from 'react';
import { PropTypes } from 'prop-types';
import Icon from '../../../../../Assets/Icon/CustomIcon';
import EduList from '../ui/EduList';
import { Swiper, SwiperSlide } from 'swiper/react';
import WriteFAB from '../../../../../Components/Ui/WriteFAB';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const tabLabels = ['종료'];

export default function M_TRA_CUSTOM(props) {
  const [value, setValue] = React.useState(0);

  const handleSearch = () => {
    props.searchRef.current.searchText = props.searchInput;
    props.setSearchClick(true);
  };

  const filteredData = React.useMemo(() => {
    if (!props.rowData1) return [];

    const currentTab = tabLabels[value];

    if (currentTab === '종료') {
      return props.rowData1;
    }

    return props.rowData1.filter((item) => item.GUBUN === currentTab);
  }, [value, props.rowData1]);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        px: 2,
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        {/* 검색창 */}
        <Box
          sx={{
            width: '100%',
            border: '1px solid #ccc',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            pr: '8px',
            my: 1,
          }}
        >
          <input
            type="text"
            placeholder="검색어를 입력해주세요."
            value={props.searchInput}
            onChange={(e) => props.setSearchInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            style={{
              height: '36px',
              fontSize: '16px',
              padding: '0 10px',
              border: 'none',
              outline: 'none',
              width: '100%',
              backgroundColor: 'transparent',
            }}
          />
          {props.searchClick ? (
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={() => {
                props.setSearchInput('');
                props.searchRef.current.searchText = '';
                props.setSearchClick(false);
              }}
            >
              <Icon.Close />
            </button>
          ) : (
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={handleSearch}
            >
              <Icon.Search />
            </button>
          )}
        </Box>

        {/* 사업장 */}
        <Swiper slidesPerView="auto" spaceBetween={6}>
          {props.searchRef.current.custList.map((item, index) => (
            <SwiperSlide key={index} style={{ width: 'auto' }}>
              <Chip
                key={index}
                sx={{
                  borderRadius: 2.5,
                  backgroundColor:
                    props.selectedChip.value === item.value
                      ? '#444B53'
                      : '#EBEBEB',
                  color:
                    props.selectedChip.value === item.value
                      ? '#FFF'
                      : 'rgba(0,0,0,0.87)',
                  '&:hover': {
                    backgroundColor:
                      props.selectedChip.value === item.value && '#333',
                  },
                }}
                label={item.name}
                onClick={() => {
                  props.setSelectedChip(item);
                  props.searchRef.current = {
                    ...props.searchRef.current,
                    custCd: item.value,
                  };
                  props.SearchLogic1();
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <p style={{ fontWeight: 'bold', padding: '0.5rem 0' }}>
          총{filteredData.length}건
        </p>
      </Box>

      {/* 리스트 */}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        {filteredData.length === 0 ? (
          <Box
            sx={{
              height: 'calc(100% - 120px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#888',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            조회된 데이터가 없습니다.
          </Box>
        ) : (
          <EduList workEndData={filteredData} userInfo={props.userInfo} />
        )}
      </Box>

      {/* 플로팅 액션 버튼 */}
      <WriteFAB handleWriteClick={props.HandleWriteClick} />
    </Box>
  );
}
